import moment from '@/assets/setups/moment'

/** parse a json date into a pretty format
@date { string } - json date
@initialFormat {String} - date initial format, so moment knows what format transforms into another
@returns { string } - parsed date example: 22 Jan 2022
*/
export const getDate = (date, initialFormat) => {
    if (date === '' || date === null || date === undefined) return null

    const timeCoordinate = initialFormat
        ? moment.utc(date, initialFormat)
        : moment.utc(date)

    return `${timeCoordinate.format('D')} ${timeCoordinate.format('MMM').charAt(0).toUpperCase()}${timeCoordinate.format('MMM').slice(1)} ${timeCoordinate.format('YYYY')}`
}

/** parse a json date into a pretty format
@date { string } - json date
@returns { string } - parsed date example: 22 Jan 2022, 15:30
*/
export const getDateWithTime = date => {
    return moment.utc(date).format('D MMM YYYY, HH:mm')
}

/** parse a json date into a pretty format
@date { string } - json date
@returns { string } - parsed date example: 2022-02-22
*/
export const getYearMonthDate = date => {
    return moment(date).format('YYYY-MM-DD')
}

/** parse a json date into a pretty format
@date { string } - json date
@returns { string } - parsed date example: 05/2022
*/
export const getMonthYear = date => {
    return moment(date).format('MM/YYYY')
}

/** parse a json date into a pretty format
@date { string } - json date
@returns { string } - parsed date example: 05/22
*/
export const getMonthYearShortVersion = date => {
    return moment(date).format('MM/YY')
}

/** parse a json date into a pretty format
@date { string } - json date
@returns { string } - parsed date example: 2022
*/
export const getYear = date => {
    return moment(date).format('YYYY')
}

/** parse a json date into a pretty format
@date { string } - json date
@returns { string } - parsed date example 15h30
*/
export const getTime = date => {
    return moment(date).format('HH[:]mm')
}

/** parse a json date into a pretty format
@date { string } - json date
@returns { string } - parsed date example 15h30:00
*/
export const getTimeWithSeconds = date => {
	return moment(date).format('HH[:]mm[:]ss')
}

/** parse a json date into a pretty format
@date { string } - json date
@returns { string } - parsed date example: 0000-00-00T00:00:00.000Z
*/
export const createJSONDateNoTimezone = date => {
	return new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toJSON()
}

/** parse a json date into a pretty format
@date { string } - json date
@returns { string } - parsed date example: 0000-00-00T23:59:59.999Z
*/
export const createJSONDateEndDay = date => {
    if (date === '' || date === null || date.length === 0) return null
	return `${new Date(date).toJSON().split('T')[0]}T23:59:59.999Z`
}

/** parse a json date into a pretty format
@date { string } - json date
@returns { string } - parsed date example: 0000-00-00T00:00:00.000Z
*/
export const createJSONDateStartDay = date => {
    if (date === '' || date === null || date.length === 0) return null
	return `${new Date(date).toJSON().split('T')[0]}T00:00:00.000Z`
}

/** get past date based on given date and X days/months before
@date { string } - start date in date or json format
@interval {number} - number to decrement given date
@intervalType {string} - ['days'(defaul), 'months']
@returns { string } - parsed date in json format example: 0000-00-00T00:00:00.000Z
*/
export const getPastDateBasedOnInterval = (date, interval, intervalType) => {
    const endDate = date

    if (intervalType && intervalType === 'months') {
        return new Date(endDate.setMonth(endDate.getMonth() - interval)).toJSON()
    }

	return new Date(endDate.setDate(endDate.getDate() - interval)).toJSON()
}

/** parse seconds into a pretty format
@time { string } - seconds
@returns { string } - returns minutes:seconds
*/
export const parseTimer = time => {
    let hours = 0
	let minutes = Math.floor(time / 60)
	const seconds = Math.floor(time - minutes * 60)
    /* If more than 60min we will apply hours */
    if (minutes > 60) {
        hours = Math.floor(minutes / 60)
        minutes = Math.floor(minutes - hours * 60)
    }

    /* Creating minutes text */
	let minutesText = minutes === 0 ? '00' : `${minutes}`
    if (hours && minutes < 10 && minutes !== 0) minutesText = `0${minutes}`
    /* Creating seconds text */
	let secondsText = seconds === 0 ? '00' : `${seconds}`
	if (secondsText < 10) secondsText = `0${seconds}`

	return hours ? `${hours}:${minutesText}:${secondsText}` : `${minutesText}:${secondsText}`
}
